"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFunctionErrorMessage = void 0;
/**
 * Returns the error message from Lambda Function ErrorClasses
 * https://github.com/OneWorkAI/platform/wiki/Lambda-Function-ErrorClasses
 */
const getFunctionErrorMessage = (error, fallbackMessage) => {
    var _a;
    try {
        const stringifiedError = error === null || error === void 0 ? void 0 : error.message;
        return ((_a = JSON.parse(stringifiedError)) === null || _a === void 0 ? void 0 : _a.message) || fallbackMessage;
    }
    catch {
        return (error === null || error === void 0 ? void 0 : error.message) || fallbackMessage || "";
    }
};
exports.getFunctionErrorMessage = getFunctionErrorMessage;
//# sourceMappingURL=errors.js.map